<template>
  <a-layout class="app-layout">
    <AppLeft
      :collapsed="collapsed"
      :sub-menu-list="subMenuList"
    />
    <a-layout
    >
      <AppHeader
        :menu-list="menuList"
        :collapsed="collapsed"
        :topMenuKeys="topMenuKeys"
        @toggle-collapsed="TOGGLE_COLLAPSED"
        @set-sub-menu="setSubMenu"
      />
      <a-layout-content
        class="app-content"
      >
        <transition name="page-transition">
          <router-view />
        </transition>
      </a-layout-content>
      <AppFooter />
    </a-layout>
  </a-layout>
</template>

<script>
import AppLeft from './AppLeft/AppLeft'
import AppHeader from './AppHeader/AppHeader'
import AppFooter from './AppFooter/AppFooter'
import { createNamespacedHelpers } from 'vuex'
import { rootMenuDirect } from '../../utils/utils'
const { mapState, mapMutations, mapActions } = createNamespacedHelpers('app')

export default {
  name: 'Layout',
  components: {
    AppHeader,
    AppLeft,
    AppFooter
  },
  data () {
    return {
    }
  },
  created () {
    // this.getBackendMenuList()
    // this.setMenusList([])
    // console.log(1)
    // await this.loadSystemMaps()
  },
  computed: {
    ...mapState([
      'collapsed',
      'menuList',
      'subMenuList',
      'topMenuKeys'
    ]),
    headerWidth () {
      const style = {
        position: 'absolute',
        background: '#fff',
        width: 'calc(100% - 200px)'
      }
      this.collapsed ? style.width = 'calc(100% - 80px)' : style.width = 'calc(100% - 200px)'
      return style
    }
  },
  methods: {
    ...mapMutations([
      'TOGGLE_COLLAPSED',
      'SET_SUB_MENUS',
      'SET_TOP_MENU_KEY'
    ]),
    ...mapActions([
      // 'loadSystemMaps',
      'setMenusList'
    ]),
    setSubMenu (item) {
      this.SET_SUB_MENUS(item)
      this.SET_TOP_MENU_KEY(item)
      this.$router.push({
        path: rootMenuDirect(item)
      })
    }
  }
}
</script>

<style scoped lang="less">
.app-layout {
  min-height: 100vh;
  .app-content {
    margin: 64px 0 0;
    /*padding: 10px;*/
    background: #f0f2f5;
    .page-transition-enter {
      opacity: 0;
    }
    .page-transition-leave-active {
      opacity: 0;
    }
    .page-transition-enter .page-transition-container,
    .page-transition-leave-active .page-transition-container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
    }
  }

  .app-footer {
    text-align: center;
    padding: 5px;
  }
}
</style>
